<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ITEM</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
<!-- Product Image -->
        <template v-if="dataImg && hasImgColumn">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template>

        <div v-for="(item, row) in dataFields" :key="row">
          
          <!-- NAME -->
          <vs-input v-if="item.Type.indexOf('varchar')>-1" :label="item.Comment" v-model="dataForm[item.Field]" class="mt-5 w-full" :name="item.Field" v-validate="'required'"/>

          <datepicker v-if="item.Type.indexOf('date')>-1" :placeholder="item.Comment" :label="item.Comment" format="yyyy-MM-dd" v-model="dataForm[item.Field]" class="mt-5 w-full" :name="item.Field"></datepicker>


          <!-- CATEGORY -->
          <vs-select v-if="item.Type.indexOf('enum')>-1" v-model="dataForm[item.Field]" :label="item.Comment" class="mt-5 w-full" :name="item.Field" v-validate="'required'">
            <vs-select-item :key="selval" :value="selval" :text="selval" v-for="selval in getArrayEnum(item.Type)" />
          </vs-select>

          <!-- PRICE -->
          <vs-input
            v-if="item.Type.indexOf('decimal')>-1"
            icon-pack="feather"
            icon="icon-creditcard"
            :label="item.Comment"
            v-model="dataForm[item.Field]"
            class="mt-5 w-full"
            v-validate="{ required: true, regex: /\d+(\.\d+)?/ }"
            :name="item.Field" />

          <span class="text-danger text-sm" v-show="errors.has(item.Field)">{{ errors.first('item-name') }}</span>
        </div>

        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <div class="upload-img mt-5" v-if="hasImgColumn">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Datepicker from 'vuejs-datepicker'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    },
    dataFields: {
      type: Array,
      default: () => {},
    }
  },
  components: {
    VuePerfectScrollbar,
    Datepicker
  },
  data() {
    return {

      dataId: null,
      dataName: "",
      dataCategory: null,
      dataImg: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      dataForm: {},
      file: null,

      category_choices: [
        {text:'Audio',value:'audio'},
        {text:'Computers',value:'computers'},
        {text:'Fitness',value:'fitness'},
        {text:'Appliance',value:'appliance'}
      ],

      order_status_choices: [
        {text:'Pending',value:'pending'},
        {text:'Canceled',value:'canceled'},
        {text:'Delivered',value:'delivered'},
        {text:'On Hold',value:'on_hold'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  watch: {
    isSidebarActive(val) {
      console.log('f', this.hasImgColumn, this.dataImg)
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues(1)
        this.$validator.reset()
      }else {
        // let { category, id, img, name, order_status, price } = JSON.parse(JSON.stringify(this.data))
        // this.dataId = id
        // this.dataCategory = category
        // this.dataName = name
        // this.dataOrder_status = order_status
        // this.dataPrice = price
        let tempdata = JSON.parse(JSON.stringify(this.data))
        this.dataImg = tempdata['img']
        for (const key in this.dataFields) {
          if (this.dataFields.hasOwnProperty(key)) {
            const element = this.dataFields[key]
            if (!['createdAt', 'updatedAt'].includes(element.Field)) {
              this.dataForm[element.Field] = tempdata[element.Field]
            }
          }
        }
        this.initValues(2)
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
    dataFields(val) {
      var found = val.find(x => x.Field === 'img')
      this.hasImgColumn = found==undefined?false:true
    }
  },
  computed: {
    dataImgInput: {
      get() {
          console.log('get')
          var found = this.dataFields.find(x => x.Field === 'img');

          if (!found) {
              return null;
          }
          return this.data.id?this.data[found.Field]:this.dataForm[found.Field];
      },
      set(val) {
          var found = this.dataFields.find(x => x.Field === 'img');

          if (!found) {
              return null;
          }
          if (this.data.id) {
            this.data[found.Field]=val;
          } else {
            this.dataForm[found.Field]=val;
          }
          console.log('set')
      }
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    hasImgColumn: {
      get(){ 
        var found = this.dataFields.find(x => x.Field == 'img')
        return found==undefined?false:true
      },
      set(newVal){
        return newVal
      } 
    },
    isFormValid() {
      var ret =  []
      for (const key in this.dataFields) {
        if (this.dataFields.hasOwnProperty(key)) {
          const element = this.dataFields[key];
          if (!['createdAt', 'updatedAt', 'img','id'].includes(element.Field)) {
            
            if (element.Type.indexOf('decimal')>-1) {
              if (this.dataForm[element.Field] == 0 || this.dataForm[element.Field] == null) {
                ret.push(element)
              }
            } else {
              if (this.dataForm[element.Field] == null) {
                ret.push(element)
              }
            }
          }
        }
      }
      return !this.errors.any() && ret.length<1
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag }
  },
  methods: {
    formatDate(date) {
      var d;
      if (date==undefined) {
        d = new Date()
      } else {
        d = new Date(date)
      }
        var month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    },
    initValues(raz) {
      this.file = null
      // if(this.data.id) return
      //   this.dataId = null
      //   this.dataName = ""
      //   this.dataCategory = null
      //   this.dataOrder_status = "pending"
      //   this.dataPrice = 0
      //   this.dataImg = null
      if(this.data.id) return
      this.dataImg = null
      for (const key in this.dataFields) {
        if (this.dataFields.hasOwnProperty(key)) {
          const element = this.dataFields[key];
          if (!['createdAt', 'updatedAt'].includes(element.Field)) {
            this.dataForm[element.Field] = ''
          }
        }
      }
      console.log(raz, this.dataForm)
    },
    async uploadFile(file) {
      let formData = new FormData();
      formData.append('file', file);
      let imgdata = await this.$http.post('https://dd.public.uz/fserver/upload',
        formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function (ret) {
        return ret.data
      })
      .catch(function (err) {
        console.log('FAILURE!!',err)
      })
      return imgdata
    },
    submitData() {
      this.$validator.validateAll().then(async result => {
          if (result) {
            if (this.$route.name=='Cashflow') {
              if (this.dataForm['entry_type']=='CashIn') {
                this.dataForm['cashin'] = this.dataForm['amount']
              }
              if (this.dataForm['entry_type']=='CashOut') {
                this.dataForm['cashout'] = -1*this.dataForm['amount']
              }
              this.dataForm['payment_date'] = this.formatDate()
              if(this.data.id !== null && this.data.id >= 0) {
                this.dataForm['updatedAt'] = this.formatDate()
              } else {
                this.dataForm['createdAt'] = this.formatDate()
              }
            } else if (this.$route.name=='Transportation'){
              if(this.data.id !== null && this.data.id >= 0) {
                this.dataForm['updatedAt'] = this.formatDate()
              } else {
                this.dataForm['createdAt'] = this.formatDate()
              }

            }
            const obj = this.dataForm

            if(this.data.id !== null && this.data.id >= 0) {
              // this.$store.dispatch("dataList/updateItem", obj).catch(err => { console.error(err) })
              if (this.file) {
                let imgdata = await this.uploadFile(this.file)
                this.dataForm['img'] = imgdata
              }

              await this.$http.post(`https://dd.public.uz/fserver/updateRow/${this.$route.name}/${this.data.id}`, this.dataForm).then(response => {
                console.log(response)
                this.initValues()
              })
            } else {
              delete obj.id

              if (this.file) {
                let imgdata = await this.uploadFile(this.file)
                obj['img'] = imgdata
              }
              await this.$http.post(`https://dd.public.uz/fserver/insertRow/${this.$route.name}/`, obj).then(response => {
                console.log(response)
                this.initValues()
              })
            }
            await this.$parent.getRecords('id', '', 0, this.$parent.itemsPerPage).then(data => {
              this.$parent.tableData = data.records
              this.$parent.totalRecords = data.total
            })

            this.$emit('closeSidebar')
          }
      })
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.file = input.target.files[0]
      }
    },
    getArrayEnum(input){
      var defi = input.replace("enum(","").replace(")","").replace(/'/g, '"')
      return JSON.parse("[" + defi + "]")
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
